import React from 'react';
import * as Routes from '@/modules/routes';
import icons, { toIconSrc } from '@/components/admin/SlideShow/Utils/icons';
import Edit from './ActionBar/ActionBarButtons/SlideShowButtons/Edit';
import { slideGroupInitialValues } from './utils';
import useLessonOverviewContext from '../useLessonOverviewContext';
import ActionBar from './ActionBar';
import Card, { CardBody } from './Card';

type SlideGroupCardProps = {
  iconColor: string,
  slideGroup: any,
  truncateTextTooltip?: boolean,
};

const SlideGroupCard = ({ iconColor, slideGroup, truncateTextTooltip = false }: SlideGroupCardProps) => {
  const lessonId = useLessonOverviewContext(state => state.lessonId);
  const programId = useLessonOverviewContext(state => state.programId);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);
  const slideGroupPath = Routes.present_mode_shared_slide_show_path(slideGroup.slideShowId, {
    from: 'lesson',
    parent_id: lessonId,
    parent_type: 'Lesson',
    program_id: programId,
    starting_slide: slideGroup.firstSlideId,
  });

  const defaultIconSrc = icons.hoiIcon;
  const hasThumbnail = slideGroup.thumbnail !== '/missing.png';

  const initialValues = slideGroupInitialValues(slideGroup);

  return (
    <div className={hasThumbnail ? 'tw-row-span-2' : undefined}>
      <Card type="slide_group">
        <CardBody
          openInNewWindow
          ariaLabel=""
          iconColor={iconColor}
          iconSrc={toIconSrc(slideGroup.icon) || defaultIconSrc}
          linkHref={slideGroupPath}
          linkLabel={slideGroup.title}
          page={slideGroup.page}
          showThumbnail={hasThumbnail}
          thumbnail={slideGroup.thumbnail}
          time={slideGroup.pacing}
          truncateTextTooltip={truncateTextTooltip}
        />
        <ActionBar
          href={slideGroupPath}
          iconType="play"
          initialValues={initialValues}
          isAssigned={slideGroup.isAssigned}
        >
          {isStaffer && (
            <Edit fromSlideShow slideShow={slideGroup} />
          )}
        </ActionBar>
      </Card>
    </div>
  );
};

export default SlideGroupCard;
